import { OK, BAD, WARN } from '../../lib/uiTokens';
import Sparkline from './Sparkline';

const pct = (v) => (v == null ? '—' : `${v.toFixed(1).replace('.', ',')} %`);

// Barva nákladového KPI dle vztahu k cíli (nižší = lepší).
const barvaNaklad = (val, cil) => {
    if (val == null || cil == null) return 'var(--text-primary)';
    if (val <= cil) return OK;
    if (val <= cil * 1.1) return WARN;
    return BAD;
};

/**
 * Tři KPI proti cílům z číselníku — food / labor / prime cost. EBITDA tu být
 * nemusí, tu nese hero panelu nad nimi; do 3.480.0 byla ve dlaždici počtvrté.
 * Sparkline drží trend šesti měsíců, to je jediná věc, kterou tabulka ani
 * struktura neřeknou.
 */
function Karta({ label, value, valueColor, sub, sparkline, cardStyle }) {
    return (
        <div className="rounded-2xl p-3 flex flex-col" style={{ ...cardStyle, overflow: 'hidden' }}>
            <div className="text-[10px] font-bold uppercase mb-1"
                style={{ letterSpacing: '0.05em', color: 'var(--text-secondary)' }}>{label}</div>
            <div className="text-[21px] font-bold tabular-nums leading-none" style={{ color: valueColor }}>{value}</div>
            {sub && <div className="text-[10.5px] mt-1 truncate" style={{ color: 'var(--text-secondary)' }} title={sub}>{sub}</div>}
            {sparkline && sparkline.length > 1 && (
                <div className="mt-auto pt-2" title="Trend posledních 6 měsíců">
                    <Sparkline body={sparkline} color={valueColor} fluid height={22} />
                </div>
            )}
        </div>
    );
}

export default function KpiKarty({ kpi, rezim = 'projekce', cardStyle }) {
    if (!kpi) return null;
    const jeProj = rezim === 'projekce';
    const znak = jeProj ? '~' : '';
    const pick = (o) => (jeProj ? o?.projekce_pct : o?.skutecnost_pct);

    const dlazdice = [
        { key: 'food',  label: 'Food cost',  o: kpi.food_cost },
        { key: 'labor', label: 'Labor cost', o: kpi.labor_cost },
        { key: 'prime', label: 'Prime cost', o: kpi.prime_cost },
    ];

    return (
        <div className="grid grid-cols-3 gap-2.5 flex-shrink-0">
            {dlazdice.map(({ key, label, o }) => {
                const val = pick(o);
                return (
                    <Karta key={key} cardStyle={cardStyle} label={label}
                        value={val == null ? '—' : `${znak}${pct(val)}`}
                        valueColor={barvaNaklad(val, o?.cil)}
                        sub={o?.cil != null ? `cíl < ${pct(o.cil)}` : ''}
                        sparkline={o?.sparkline} />
                );
            })}
        </div>
    );
}
